import axiosClient from "./axiosClient";

/* ---------------- AUTH HEADER ---------------- */

const authHeader = (token) => {
  if (!token) {
    throw new Error("Missing authentication token");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

/* ---------------- FETCH PRODUCTS ---------------- */

export async function fetchProducts(token, page = 0, size = 20) {
  const res = await axiosClient.get("/products/admin", {
    params: {
      page,
      size,
      sortBy: "createdAt",
      direction: "DESC",
    },
    headers: authHeader(token),
  });

  return res.data;
}

/* ---------------- APPROVE PRODUCT ---------------- */

export async function approveProduct(token, productId) {
  if (!productId) {
    throw new Error("Missing productId");
  }

  return axiosClient.put(
    `/products/${productId}/moderate`,
    {
      status: "APPROVED",
      reason: "Approved by moderator",
    },
    {
      headers: authHeader(token),
    },
  );
}

/* ---------------- REJECT PRODUCT ---------------- */

export async function rejectProduct(token, productId, reason) {
  if (!productId) {
    throw new Error("Missing productId");
  }

  return axiosClient.put(
    `/products/${productId}/moderate`,
    {
      status: "REJECTED",
      reason,
    },
    {
      headers: authHeader(token),
    },
  );
}
